import axios from "axios";
import { useTranslation } from "TranslationContext";
import { getAuthToken, getUserLanguage } from "./local-storage";
import apiHelper, { apiExternalHelper } from "services/apiHelper";
import { countryToLanguageMap, dayTranslations, monthTranslations } from "configs/common";
import { setUserLanguage } from "utils/local-storage";
import CustomToast from "components/CustomToast";
import { useEffect, useState } from "react";
import { IDENTITY } from "configs/brandConfig";

export const isObject = (value) => {
  const type = typeof value;
  return value != null && (type === "object" || type === "function");
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const markStates = (sobj, self) => {
  if (!isObject(sobj)) {
    throw new Error("mark: invalid sobj, exepect a object");
  }
  const selfKeys = Object.keys(self);

  Object.entries(sobj).forEach(([key, val]) => {
    if (!selfKeys.includes(key)) return false;
    if (!Array.isArray(val) && isObject(val) && self[key] !== null) {
      // eslint-disable-next-line no-param-reassign
      self[key] = Object.assign(self[key], val);
    } else {
      // eslint-disable-next-line no-param-reassign
      self = Object.assign(self, { [key]: val });
    }
  });

  return false;
};

export function NumberToTime(duration) {
  const hour = Math.floor(duration / 60 / 60);
  const minute = Math.floor((duration - hour * 60 * 60) / 60);
  return `${hour === 0 ? "00" : hour < 10 ? `0${hour}` : hour}:${
    minute === 0 ? "00" : minute < 10 ? `0${minute}` : minute
  }`;
}

export function formatDuration(seconds) {
  seconds = Number(seconds);
  const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
  const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
  const s = Math.floor(seconds % 60).toString().padStart(2, '0');
  return `${h}:${m}:${s}`;
}

export function NumberToTimeText(duration) {
  const now = Date.now();
  const remainigTime = now - duration;
  const remainDays = Math.floor(remainigTime / (24 * 60 * 60 * 1000));
  const remainDaysInSeconds = remainDays * 24 * 60 * 60 * 1000;
  const remainHours = Math.floor(
    (remainigTime - remainDaysInSeconds) / (60 * 60 * 1000)
  );
  const remainHoursInSeconds = remainHours * 60 * 60 * 1000;
  const remainMinutes = Math.floor(
    (remainigTime - (remainDaysInSeconds + remainHoursInSeconds)) / (60 * 1000)
  );
  // const remainMinutesInSeconds = remainMinutes * 60 * 1000;
  // const remainSeconds = Math.floor(
  //   (remainigTime -
  //     (remainDaysInSeconds + remainHoursInSeconds + remainMinutesInSeconds)) /
  //   1000
  // );

  return `${
    remainDays === 0
      ? ""
      : remainDays < 10
      ? `0${remainDays} Days,`
      : `${remainDays} Days,`
  }  ${
    remainHours === 0
      ? ""
      : remainHours < 10
      ? `0${remainHours} Hours,`
      : `${remainHours} Hours,`
  } ${
    remainMinutes === 0
      ? ""
      : remainMinutes < 10
      ? `0${remainMinutes} Minute`
      : `${remainMinutes} Minute`
  } `;
}

export function TimeToNumber(time) {
  const hour = time.substring(0, 2);
  const minute = time.substring(3, 5);
  return hour * 60 * 60 + minute * 60;
}

export function generateDatabaseDateTime(date) {
  if (date === "0") {
    return "0";
  }

  const p = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    // timeZone: "GMT",
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );

  return `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}:${p.second}`;
}
export function generateDatabaseDateTimeWithSecond(date) {
  const p = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "GMT",
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );

  return `${p.day} ${p.month} ${p.year} ${p.hour}:${p.minute}:${p.second}`;
}

export function postScheduleTimeToDate(date) {
  const p = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    // timeZone: "GMT",
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );
  return `${p.month}/${p.day}/${p.year} ${p.hour}:${p.minute}`;
}

export function generateDatabaseDate(date) {
  const p = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );

  return `${p.month}/${p.day}/${p.year} ${p.hour}:${p.minute}:${p.second}`;
}

export function generateDate(date) {
  const p = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );

  return `${p.month}/${p.day}/${p.year}`;
}

export function generateTime(date) {
  const p = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );

  return `${p.hour}:${p.minute}`;
}

export function lastLocationTime(date) {
  const p = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .formatToParts(date)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );
  return `${p.hour}:${p.minute}:${p.second}`;
}

export function isYesterday(date) {
  const inputDate = new Date(date);
  if (!(inputDate instanceof Date)) {
    throw new Error("Date is wrong");
  }
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return (
    inputDate.getDate() === yesterday.getDate() &&
    inputDate.getMonth() === yesterday.getMonth() &&
    inputDate.getFullYear() === yesterday.getFullYear()
  );
}

export function isToday(date) {
  const inputDate = new Date(date);
  if (!(inputDate instanceof Date)) {
    throw new Error("Date is wrong");
  }
  const today = new Date();
  today.setDate(today.getDate());

  return (
    inputDate.getDate() === today.getDate() &&
    inputDate.getMonth() === today.getMonth() &&
    inputDate.getFullYear() === today.getFullYear()
  );
}

export function chatTiming(timestamp) {
  if (isYesterday(timestamp)) {
    return "yesterday";
  }
  const p = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "GMT",
  })
    .formatToParts(timestamp)
    .reduce(
      (acc, part) => {
        acc[part.type] = part.value;
        return acc;
      },
      {
        year: undefined,
        month: undefined,
        day: undefined,
        hour: undefined,
        minute: undefined,
        second: undefined,
      }
    );
  if (isToday(timestamp)) {
    return `${p.hour}:${p.minute}`;
  } else {
    return `${p.day}/${p.month}/${p.year}`;
  }
}

export function formattedTime(secondsToHm) {
  var d = Number(secondsToHm);
  var h = Math.floor(d / 3600);
  var m = Math.floor((d % 3600) / 60);
  var s = Math.floor((d % 3600) % 60);
  //m = s > 0 ? m + 1 : m;

  var hDisplay = h > 0 ? h + "h " : "";
  var mDisplay = m > 0 ? m + (h > 0 ? "m" : "m") : "";
  var sDisplay = h === 0 && m === 0 && s > 0 ? "1m" : "";

  return hDisplay + mDisplay + sDisplay;
}

export const formatTime = (seconds) => {
  const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
  const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
  const secs = String(seconds % 60).padStart(2, "0");
  if (hrs > 0) {
    return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(
      2,
      "0"
    )}:${String(secs).padStart(2, "0")}`;
  } else {
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }
};

export const getDateString = (daysbefore) => {
  const date = new Date();
  date.setDate(date.getDate() - daysbefore); // Adjust the date based on daysbefore

  const formattedDate = date
    .toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
    })
    .replace(
      /(\w)(\w*)/,
      (match, first, rest) => first.toUpperCase() + rest.toLowerCase()
    ); // Capitalize first letter

  return formattedDate;
};
export const getPerstange = (totalUsage, appusage) => {
  var per = Math.floor((appusage / totalUsage) * 100);
  return per;
};

export const dataDownload = (imei, appName) => {
  const token = getAuthToken();
  let url = `${getAPIURL()}api/dataliberation/download/${imei}/${appName}`;
  axios({
    url: url,
    method: "GET",
    responseType: "blob", // Set the response type to blob
    headers: {
      Authorization: `Bearer ${token}`, // Add the token to the Authorization header
    },
    // Optionally, you can send parameters in the query string if required by your API
    // Example: params: { fileId: 123 }
  })
    .then((response) => {
      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // Create a temporary anchor element
      const a = document.createElement("a");
      a.href = url;
      // Specify the file name
      a.download = "data.html"; // Change to your desired filename
      // Append the anchor element to the document body
      document.body.appendChild(a);
      // Trigger the click event to initiate download
      a.click();
      // Remove the anchor element
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

export const allDataDownload = (imei) => {
  const token = getAuthToken();
  let url = `${getAPIURL()}api/dataliberation/download/all/${imei}`;
  axios({
    url: url,
    method: "GET",
    responseType: "blob", // Set the response type to blob
    headers: {
      Authorization: `Bearer ${token}`, // Add the token to the Authorization header
    },
    // Optionally, you can send parameters in the query string if required by your API
    // Example: params: { fileId: 123 }
  })
    .then((response) => {
      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // Create a temporary anchor element
      const a = document.createElement("a");
      a.href = url;
      // Specify the file name
      a.download = `${imei}_data.zip`;
      // Append the anchor element to the document body
      document.body.appendChild(a);
      // Trigger the click event to initiate download
      a.click();
      // Remove the anchor element
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
};

// export const saveTokenAndScheduleDeletion = (token) => {
//   // Save the token in localStorage
//   setAuthToken(token);

//   // Set the time after which you want to delete the token (1 hour)
//   //const deletionTime = new Date().getTime() + 60 * 60 * 1000; // 1 hour in milliseconds
//   const deletionTime = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours in milliseconds
//   // Schedule the deletion of the token after one hour
//   setTimeout(() => {
//     // Check if the token exists in localStorage before attempting to delete it
//     if (getAuthToken()) {
//       removeAuthToken();
//     }
//   }, deletionTime - new Date().getTime());
// };
// export const saveUserDetailsAndScheduleDeletion = (userDetails) => {
//   // Save the token in localStorage
//   setUserDetails(userDetails);

//   // Set the time after which you want to delete the userDetails (1 hour)
//   const deletionTime = new Date().getTime() + 60 * 60 * 1000; // 1 hour in milliseconds

//   // Schedule the deletion of the userDetails after one hour
//   setTimeout(() => {
//     // Check if the token exists in localStorage before attempting to delete it
//     if (getUserDetails()) {
//       removeUserDetails();
//     }
//   }, deletionTime - new Date().getTime());
// };

export const differenceDaysHoursMinutesSeconds = (time) => {
  const now = Date.now();
  const remainigTime = Math.abs(time - now);
  const remainDays = Math.floor(remainigTime / (24 * 60 * 60 * 1000));
  const remainDaysInSeconds = remainDays * 24 * 60 * 60 * 1000;
  const remainHours = Math.floor(
    (remainigTime - remainDaysInSeconds) / (60 * 60 * 1000)
  );
  const remainHoursInSeconds = remainHours * 60 * 60 * 1000;
  const remainMinutes = Math.floor(
    (remainigTime - (remainDaysInSeconds + remainHoursInSeconds)) / (60 * 1000)
  );
  const remainMinutesInSeconds = remainMinutes * 60 * 1000;
  const remainSeconds = Math.floor(
    (remainigTime -
      (remainDaysInSeconds + remainHoursInSeconds + remainMinutesInSeconds)) /
      1000
  );
  return { remainDays, remainHours, remainMinutes, remainSeconds };
};

export const categoryNameConvertToDisplayName = (cat) => {
  let category = cat;
  if (cat === "drug") {
    category = "Drugs/Alcohol";
  } else if (cat === "bullying") {
    category = "Bullying";
  } else if (cat === "violence") {
    category = "Violence";
  } else if (cat === "sexting" || cat === "nudity") {
    category = "Sexting/Nudity";
  }else {
    try {
      category = JSON.parse(category); // Parse the JSON string
    } catch (error) {
      console.error("Invalid JSON format", error);
      return category;
    }
  
    // Extract "cat" values from "data"
    category = [
      ...category.data.map((item) => item.cat),
    ];
  }
  return category;
};

export const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Script load error for ${src}`));
    document.head.appendChild(script);
  });
};

export const getMediaURL = async (url, imei, type) => {
    const newUrl = `api/files/downloadfile/${imei}?` + url.split("?")[1] + `&type=${type}`;
    const res = await apiHelper(newUrl, "get", {}, {});
    const fileUrl = res.data.data;

    if (!fileUrl) throw new Error("No file URL returned");

    //TO do check mp4 why this code added
    // if (fileUrl.toLowerCase().includes(".mp4")) {
    //   return { data: { data: fileUrl } };
    // }

    const fileName = decodeURIComponent(fileUrl.split("?")[0].split("/").pop());
    const lowerUrl = fileUrl.toLowerCase();
  
    if(hostname === IDENTITY.SUB_MAIN_CN || getUserLanguage() === "ch"){
      return { data: { data: fileUrl, filename: fileName } };
    } else if (hostname === IDENTITY.NAME && lowerUrl.includes("finalurl") && lowerUrl.includes("xamzserversideencryption")) {
        try {
          const { updatedUrl, headers } = buildRequest(fileUrl);
          const response = await fetch(updatedUrl, { headers });

          if (!response.ok) throw new Error(`Failed to fetch file: ${response.status}`);

          const blob = await response.blob();
          const objectUrl = URL.createObjectURL(blob);
          return { data: { data: objectUrl, filename: fileName } };
        } catch (s3Error) {
          console.warn("S3 direct fetch failed, falling back to backend:", s3Error);
          return { data: { data: fileUrl, filename: fileName } };
        }
    } else {
      return { data: { data: fileUrl, filename: fileName } };
    }
};

export const TranslateWithSpecialCharacters = (text) => {
  const { translate } = useTranslation();
  const combinedPattern = /(\d+|[./~`!])/g;
  const parts = text.split(combinedPattern);
  const translatedParts = parts.map((part) => translate[part.trim()] || part);
  // Reconstruct the string by joining translated parts
  return translatedParts.join(" ");
};

export const getLanguageForCountry = (countrycode, setLocale) => {
  const getlanguagecode = countryToLanguageMap[countrycode] || "ch";
  setUserLanguage(getlanguagecode);
  setLocale(getlanguagecode);
};

export const handleDeleteSelected = (
  type,
  selectedRows,
  currentDevice,
  deleteAllApi,
  mutate,
  toast,
  setSelectedData,
  setDeleteAll,
  onDeleteModalClose
) => {
  if (!Array.isArray(selectedRows) || selectedRows.length === 0) {
    toast({
      position: "top-right",
      status: "error",
      render: () => (
        <CustomToast
          bgColor={"red"}
          message="No items selected. Please select rows to delete."
        />
      ),
    });
    return;
  }
  deleteAllApi(type, currentDevice, selectedRows)
    .then((res) => {
      if (type !== "dataliberation") {
        mutate();
      }
      toast({
        position: "top-right",
        status: "success",
        render: () => <CustomToast message={res.data.message} />,
      });
      if (type === "dataliberation") {
        setSelectedData([]);
        setDeleteAll(false);
      }
      if (onDeleteModalClose) {
        onDeleteModalClose();
      }
    })
    .catch((err) => {
      console.error(err);
      toast({
        position: "top-right",
        status: "error",
        render: () => (
          <CustomToast
            bgColor={"red"}
            message={err.response?.data?.message || "An error occurred."}
          />
        ),
      });
    });
};

export function getPersantage(totalUsage, appUsage) {
  var per = (appUsage / totalUsage) * 100;
  return per.toFixed(0);
}

export function getCurrentTimeInTimeZone(timeZone) {
  const now = new Date();
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone,
    weekday: "long",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  });
  const parts = formatter.formatToParts(now);
  const timeParts = {};
  parts.forEach(({ type, value }) => {
    timeParts[type] = value;
  });
  return timeParts;
}

// Get the current time in IST

export const openVideotab = async (getfetchurl) => {
  try {
    if (getfetchurl) {
      const videoWindow = window.open("", "_blank");
      videoWindow.document.write(`
             <div text-align="center">
            <video controls autoplay muted width="500px" height="500px">
          <source src="${getfetchurl}" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        </div>
        `);
      videoWindow.document.close(); // To make sure the content is properly loaded
    }
  } catch (error) {
    console.error("Error fetching media URL:", error); // Handle errors
  }
};

export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  const now = new Date();

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  if (date >= today) {
    return `Today ${date.toLocaleTimeString("en-GB")}`;
  } else if (date >= yesterday) {
    return `Yesterday ${date.toLocaleTimeString("en-GB")}`;
  } else {
    return `${date.getDate()} ${date.toLocaleString("en-GB", {
      month: "short",
    })} ${date.toLocaleTimeString("en-GB")}`;
  }
}

export function formatSeconds(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return [hours, minutes, secs]
    .map((unit) => String(unit).padStart(2, "0")) // Ensure 2-digit format
    .join(":");
}

export const formatDate = (timestamp) => {
  // Handle cases where timestamp might be undefined
  const languageMode = getUserLanguage();
  
  if (!timestamp) return "Invalid Date";
  
  // Convert to Date object - handle both milliseconds and string formats
  const dateObject = new Date(
    typeof timestamp === 'string' ? 
    timestamp.includes('T') ? timestamp : Number(timestamp) 
    : timestamp
  );
  
  // Validate the date
  if (isNaN(dateObject.getTime())) {
    console.error("Invalid timestamp:", timestamp);
    return "Invalid Date";
  }

  const months = monthTranslations[languageMode] || monthTranslations.en;
  const dayTexts = dayTranslations[languageMode] || dayTranslations.en;
  const now = new Date();
  
  // Compare dates (ignoring time)
  const isToday = dateObject.toDateString() === now.toDateString();
  const isYesterday = (() => {
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return dateObject.toDateString() === yesterday.toDateString();
  })();

  // if (isToday) return "Today";
  // if (isYesterday) return "Yesterday";

  if (isToday) return dayTexts.today;
  if (isYesterday) return dayTexts.yesterday;
  
  return `${dateObject.getDate()} ${months[dateObject.getMonth()]} ${dateObject.getFullYear()}`;
};

export const useDeviceDetection = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    isDesktop: !!navigator.maxTouchPoints ? 'mobile' : 'computer',
    orientation: !navigator.maxTouchPoints 
      ? 'desktop' 
      : !window.screen.orientation.angle 
        ? 'portrait' 
        : 'landscape'
  });

  useEffect(() => {
    function handleResize() {
      setDeviceInfo({
        isDesktop: !!navigator.maxTouchPoints ? 'mobile' : 'computer',
        orientation: !navigator.maxTouchPoints 
          ? 'desktop' 
          : !window.screen.orientation.angle 
            ? 'portrait' 
            : 'landscape'
      });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return deviceInfo;
}

const { hostname } = window.location;

export function getAPIURL() {
  // if (hostname === "IDENTITY.SUB_MAIN_CN") {
  //   return process.env.REACT_APP_API_URL.replace(IDENTITY.NAME, IDENTITY.SUB_MAIN_CN);
  // }
  return process.env.REACT_APP_API_URL;
}

export const UploadUrl = async (uploadUrl, ackUrl, blobData, contentType = "application/octet-stream") => {
  const token = getAuthToken();
  try {
      // Create blob if not already created (for backward compatibility)
      const blob = blobData instanceof Blob 
          ? blobData 
          : new Blob([blobData], { type: contentType });

      // Step 1: Upload Blob to S3 using PUT
      await apiExternalHelper(uploadUrl, blob, "put", {
          headers: {
              "Content-Type": blob.type || contentType,
          },
      });

      // Step 2: Send Acknowledgment if needed
      const finalAckUrl = ackUrl.replace("<iFilesize>", blob.size.toString());

      await apiExternalHelper(finalAckUrl, null, "get", {
          headers: {
              Authorization: `Bearer ${token}`,
          },
      });

      console.log("Ack sent successfully!");
  } catch (error) {
      console.error("Upload failed:", error);
  }
};

// export function replaceHostname(oldUrl) {
//   const { hostname } = window.location;
//   if (hostname === IDENTITY.SUB_MAIN_CN) {
//     const url = new URL(oldUrl);

//     url.hostname = IDENTITY.SUB_MAIN_CN;

//     return url.toString();
//   }
//   return oldUrl;
// }

export function replaceHostname(oldUrl) {
  const { hostname } = window.location;
  if (hostname === "cn.anquanshouhu.top") {
    return oldUrl?.replace(IDENTITY.NAME,IDENTITY.SUB_MAIN_CN)
  }
  return oldUrl;
}

// 🔹 helper to build final URL + headers
export const buildRequest = (fileUrl) => {
  const urlObj = new URL(fileUrl);
  const params = new URLSearchParams(urlObj.search);

  const finalHost = params.get("finalurl");
  const cleanPath = urlObj.pathname.replace(/^\/s3/, "");

  const updatedUrl = `https://${finalHost}${cleanPath}?${params.toString()}`;

  const headers = {
    "x-amz-server-side-encryption-customer-algorithm": params.get("xamzserversideencryptioncustomeralgorithm"),
    "x-amz-server-side-encryption-customer-key": decodeURIComponent(params.get("xamzserversideencryptioncustomerkey")),
    "x-amz-server-side-encryption-customer-key-MD5": params.get("xamzserversideencryptioncustomerkeymd5"),
  };

  return { updatedUrl, headers };
};

// WGS-84 to GCJ-02 (Amap) conversion for Mainland China
const a = 6378245.0;
const ee = 0.00669342162296594323;

function transformLat(x, y) {
  let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin(y / 3.0 * Math.PI)) * 2.0 / 3.0;
  ret += (160.0 * Math.sin(y / 12.0 * Math.PI) + 320 * Math.sin(y * Math.PI / 30.0)) * 2.0 / 3.0;
  return ret;
}

function transformLon(x, y) {
  let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
  ret += (20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0 / 3.0;
  ret += (20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin(x / 3.0 * Math.PI)) * 2.0 / 3.0;
  ret += (150.0 * Math.sin(x / 12.0 * Math.PI) + 300.0 * Math.sin(x / 30.0 * Math.PI)) * 2.0 / 3.0;
  return ret;
}

function outOfChina(lat, lon) {
  return !(lon > 73.66 && lon < 135.05 && lat > 3.86 && lat < 53.55);
}

export function wgs84ToGcj02(lat, lon) {
  lat = parseFloat(lat);
  lon = parseFloat(lon);
  if (isNaN(lat) || isNaN(lon) || outOfChina(lat, lon)) {
    return [lat, lon];
  }
  let dLat = transformLat(lon - 105.0, lat - 35.0);
  let dLon = transformLon(lon - 105.0, lat - 35.0);
  let radLat = lat / 180.0 * Math.PI;
  let magic = Math.sin(radLat);
  magic = 1 - ee * magic * magic;
  let sqrtMagic = Math.sqrt(magic);
  dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * Math.PI);
  dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * Math.PI);
  let mgLat = lat + dLat;
  let mgLon = lon + dLon;
  return [mgLat, mgLon];
}
  
